import { Entity } from 'dexie';
import type { AppDB } from '../db';

class Device extends Entity<AppDB> {
  public active_distance: boolean;
  public allow_trip_without_ignition: boolean;
  public attributes: any | null;
  public available: boolean;
  public avr_fuel_consumption: number | null;
  public buying_price: number | null;
  public commissionning_timestamp: number | null;
  public conservation: number;
  public creation_timestamp: number;
  public daily_base: number;
  public device_type: number;
  public engine: number;
  public engine_caliber: number;
  public engine_date: string | null;
  public engine_diff: number;
  public first_trip_timestamp: number;
  public fk_fuel_type: number | null;
  public force_trip_with_ignition: boolean;
  public imei: string;
  public inverted_inputs: number;
  public mileage: number;
  public mileage_caliber: number;
  public mileage_date: string | null;
  public mileage_diff: number;
  public monthly_base: number;
  public pnd: boolean;
  public registration: string;
  public securized_access: boolean;
  public selling_price: number | null;
  public snexternal: string | null;
  public summary: string;
  public symbol: number;
  public trip_with_ignition_detection_time: number;
  public uid: number;
  public uid_parent: number;
  public uid_picture: number | null;
  public uid_position: number;
  public uid_virtual: number | null;
  public location_date: number;

  public source = 'device';

  public normalize() {}
}

export default Device;
